import { render, staticRenderFns } from "./Jobs.vue?vue&type=template&id=72d8a17f&scoped=true"
import script from "./Jobs.vue?vue&type=script&lang=js"
export * from "./Jobs.vue?vue&type=script&lang=js"
import style0 from "./Jobs.vue?vue&type=style&index=0&id=72d8a17f&prod&lang=scss"
import style1 from "./Jobs.vue?vue&type=style&index=1&id=72d8a17f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d8a17f",
  null
  
)

export default component.exports